import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const zh = {
  nav: {
    home: "首页",
    about: "晶灵简介",
    zeroSpace: "零度空间",
    products: "晶灵产品",
    angelina: "Angelina",
    crystals: "水晶介绍",
    booking: "人生预约",
    member: "会员系统",
    login: "登录",
    register: "注册",
    logout: "退出",
    admin: "管理后台",
    dashboard: "会员中心",
    agentCenter: "代理中心",
    profile: "个人资料",
    cart: "购物车",
  },
  common: {
    zh: "中文",
    en: "EN",
    loading: "加载中...",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    submit: "提交",
    back: "返回",
    edit: "编辑",
    delete: "删除",
    view: "查看",
    upload: "上传",
    share: "分享",
    copy: "复制链接",
    copied: "已复制",
    yes: "是",
    no: "否",
    optional: "选填",
    required: "必填",
    all: "全部",
    search: "搜索",
    filter: "筛选",
    price: "价格",
    stock: "库存",
    active: "上架",
    inactive: "下架",
    featured: "推荐",
    total: "合计",
    subtotal: "小计",
    quantity: "数量",
    empty: "暂无数据",
    processing: "处理中...",
    saved: "已保存",
    close: "关闭",
    comingSoon: "即将推出",
    comingSoonDesc: "此板块正在精心打磨中，敬请期待。",
  },
  brand: {
    tagline: "文化 · 创意 · 灵性生活",
    subtitle: "以东方美学承载现代品味",
  },
  home: {
    heroTitle: "承晶之灵 · 创心之美",
    heroSubtitle: "水晶、风水、能量、香与莲花——严选文创好物，为生活注入静谧与灵感。",
    ctaShop: "探索晶灵产品",
    ctaAbout: "了解晶灵",
    featured: "推荐好物",
    featuredDesc: "本季精选，为你甄选每一件温润有灵的作品。",
    todayFortune: "今日运程",
    todayFortuneDesc: "运程模块即将上线，敬请期待第三阶段。",
    reminderTitle: "温馨提醒",
    reminderBody: "您的个人资料尚未完善（出生年月日时），完善后可获得更精准的服务。",
    completeProfile: "去完善资料",
    dismiss: "稍后",
  },
  auth: {
    login: "登录",
    register: "注册",
    email: "邮箱",
    password: "密码",
    name: "姓名",
    phone: "电话",
    identity: "身份",
    member: "会员",
    agent: "销售代理",
    agentNote: "选择销售代理，需管理员审核后方可解锁代理功能。审核期间可正常使用会员功能。",
    referralCode: "推荐码（选填）",
    referralApplied: "推荐码已应用",
    haveAccount: "已有账号？",
    noAccount: "还没有账号？",
    loginHere: "点此登录",
    registerHere: "立即注册",
    welcome: "欢迎回来",
    google: "使用 Google 登录",
    googleSignUp: "使用 Google 注册",
    or: "或",
    signingIn: "正在登录…",
    createAccount: "创建账户",
    agentPending: "您的代理身份正在审核中，暂以会员身份使用。",
    agentApproved: "您的代理身份已通过审核。",
    agentRejected: "您的代理申请未通过。",
  },
  profile: {
    title: "个人资料",
    gender: "性别",
    male: "男",
    female: "女",
    other: "其他",
    birthDate: "出生日期",
    birthTime: "出生时辰",
    birthYear: "年",
    birthMonth: "月",
    birthDay: "日",
    birthHour: "时",
    unknownHour: "不详",
    complete: "资料完整",
    incomplete: "资料未完整",
    updated: "资料已更新",
  },
  products: {
    title: "晶灵产品",
    all: "全部",
    crystal: "水晶",
    fengshui: "风水",
    energy: "能量",
    incense: "香与蜡烛",
    lotus: "莲花",
    addToCart: "加入购物车",
    buyNow: "立即购买",
    outOfStock: "暂时缺货",
    inStock: "现货",
    shareTitle: "分享此商品",
    shareCopy: "复制链接",
    shareWa: "WhatsApp 分享",
    description: "商品描述",
    added: "已加入购物车",
    empty: "暂无商品",
  },
  cart: {
    title: "购物车",
    empty: "购物车是空的",
    emptyDesc: "去挑选喜欢的晶灵好物吧。",
    checkout: "去结算",
    remove: "移除",
    continueShopping: "继续选购",
    itemsCount: "共 {{n}} 件",
  },
  checkout: {
    title: "结算",
    loginRequired: "结算需要先登录",
    shipping: "收货信息",
    shippingName: "收件人姓名",
    shippingPhone: "收件电话",
    shippingAddress: "收件地址",
    notes: "备注（选填）",
    bankInfo: "银行转账信息",
    bankName: "银行",
    accountName: "户名",
    accountNumber: "账号",
    amount: "转账金额",
    placeOrder: "提交订单",
    afterOrder: "提交订单后请转账并上传付款凭证。",
  },
  order: {
    title: "订单",
    orderNo: "订单编号",
    status: "状态",
    date: "下单时间",
    uploadProof: "上传付款凭证",
    reuploadProof: "重新上传凭证",
    proofUploaded: "凭证已上传，等待管理员审核。",
    confirmed: "订单已确认。感谢您的支持！",
    rejected: "订单被拒绝",
    rejectReason: "拒绝原因",
    contactWa: "WhatsApp 联系我们",
    orderSuccess: "订单已生成",
    orderSuccessDesc: "请转账后上传付款凭证，我们会尽快确认订单。",
    goToOrder: "查看订单",
    history: "订单记录",
    statuses: {
      pending_payment: "等待付款",
      proof_uploaded: "凭证已上传",
      confirmed: "已确认",
      rejected: "已拒绝",
      cancelled: "已取消",
    },
  },
  admin: {
    title: "管理后台",
    orders: "订单管理",
    products: "商品管理",
    settings: "站点设置",
    users: "用户管理",
    newProduct: "新增商品",
    editProduct: "编辑商品",
    productName: "商品名称",
    productDesc: "商品描述",
    category: "分类",
    price: "原价",
    promoPrice: "促销价",
    images: "商品图片",
    imagesHint: "上传图片或粘贴图片链接",
    addImageUrl: "添加图片链接",
    uploadImage: "上传图片",
    orderList: "全部订单",
    orderDetail: "订单详情",
    viewProof: "查看凭证",
    confirmOrder: "确认订单",
    rejectOrder: "拒绝订单",
    rejectReasonHint: "请填写拒绝原因",
    uploadForCustomer: "代客户上传凭证",
    stripeRefundNotice: "提示：此订单已通过 Stripe 支付。此处拒绝将撤销积分与佣金，但退款请在 Stripe 后台手动处理。",
    contactCustomer: "联系客户",
    saveSettings: "保存设置",
    settingsSaved: "设置已保存",
  },
  footer: {
    contact: "联系我们",
    quickLinks: "快速链接",
    rights: "版权所有",
    tagline: "文化 · 创意 · 灵性",
  },
  points: {
    title: "我的积分",
    balance: "积分余额",
    history: "积分记录",
    use: "使用积分抵扣",
    hint: "1 积分 = RM 1，可抵扣订单金额",
    max: "可用",
    types: { earn: "获得", spend: "使用", reverse: "回撤", refund: "退回" },
  },
  agentHub: {
    title: "代理中心",
    referralCode: "我的推荐码",
    referralLink: "推荐链接",
    copyLink: "复制链接",
    totalEarned: "累计佣金",
    withdrawable: "可提现",
    referredCount: "推荐人数",
    monthly: "每月收益",
    commissions: "佣金记录",
    referrals: "推荐会员",
    withdraw: "申请提现",
    withdrawals: "提现记录",
    amount: "金额 (RM)",
    minAmount: "最低 RM100",
    bankRequired: "请先在个人资料中完善银行信息",
    bankInfo: "银行信息",
    bankHolder: "户名",
    bankName: "银行",
    bankNumber: "账号",
    statuses: { pending: "审核中", paid: "已支付", rejected: "已拒绝" },
    requestSubmitted: "提现申请已提交",
    joinDate: "加入时间",
  },
  adminP2: {
    withdrawals: "提现管理",
    orgChart: "组织图",
    users: "用户管理",
    createUser: "创建用户",
    editUser: "编辑用户",
    resetPassword: "重置密码",
    newPassword: "新密码",
    role: "角色",
    agentStatus: "代理状态",
    approve: "通过",
    reject: "拒绝",
    markPaid: "标记已支付",
    downlines: "下线",
    noDownlines: "暂无下线",
    all: "全部",
  },
  fortune: {
    title: "今日运程",
    ganzhi: "干支",
    lunar: "农历",
    zodiac: "生肖",
    clash: "冲煞",
    mood: "整体运势",
    yi: "宜",
    ji: "忌",
  },
  events: {
    title: "零度空间",
    subtitle: "课程与工作坊",
    signup: "立即报名",
    location: "地点",
    price: "费用",
    capacity: "名额",
    signupTitle: "报名信息",
    noteHint: "备注（选填）",
    signupSuccess: "报名成功，等待管理员确认",
    mySignups: "我的报名",
    statuses: { pending: "待确认", confirmed: "已确认", rejected: "已拒绝" },
    empty: "暂无活动",
    full: "名额已满",
  },
  booking: {
    title: "人生预约",
    subtitle: "一对一命理咨询",
    pickDate: "选择日期",
    pickTime: "选择时段",
    depositNotice: "预约需先支付定金以确认时段（价格由所选师傅决定）",
    concern: "咨询主题",
    submit: "提交预约",
    myBookings: "我的预约",
    minutes: "分钟",
    statuses: { pending_payment: "待付款", proof_uploaded: "凭证已上传", confirmed: "已确认", rejected: "已拒绝" },
    empty: "暂无预约",
    noSlots: "暂无可预约时段",
    freed: "时段已释放",
    afterPay: "预约生成后请按所示金额转账并上传凭证",
  },
  crystals: {
    title: "水晶介绍",
    subtitle: "水晶百科 · 疗愈知识",
    readMore: "继续阅读",
    empty: "暂无文章",
    categories: "分类",
  },
  angelina: {
    title: "Angelina",
    subtitle: "晶灵代言人",
    recommends: "Angelina 推荐好物",
  },
  reports: {
    title: "报告申请",
    subtitle: "数字报告 · 奇门报告",
    types: { numerology: "数字报告", qimen: "奇门报告" },
    apply: "申请报告",
    noteHint: "补充说明（选填）",
    requireBirth: "申请前需完善出生日期与时辰",
    goProfile: "去完善资料",
    download: "下载报告",
    myRequests: "我的申请",
    statuses: { pending: "审核中", completed: "已完成", rejected: "已拒绝" },
    applied: "已提交申请",
    empty: "暂无申请",
  },
  analytics: {
    title: "销售业绩分析",
    revenue: "累计营收",
    orders: "订单数",
    pending: "待处理订单",
    members: "会员数",
    agents: "代理数",
    monthlyRevenue: "每月营收",
    categoryRevenue: "分类营收",
    topProducts: "热门商品",
    topAgents: "本月佣金榜",
    recent: "最近订单",
  },
  adminP3: {
    events: "课程管理",
    signups: "报名管理",
    exportCsv: "导出 CSV",
    slots: "时段管理",
    newSlot: "新增时段",
    bookings: "预约管理",
    articles: "文章管理",
    newArticle: "新增文章",
    editArticle: "编辑文章",
    articleCats: "文章分类",
    angelinaCms: "Angelina 内容",
    reports: "报告管理",
    uploadReport: "上传报告 PDF",
    analytics: "业绩分析",
  },
  adminCategories: {
    nav: "产品分类",
  },
  masters: {
    title: "命理师傅",
    subtitle: "师傅介绍",
    pickMaster: "选择师傅",
    all: "全部师傅",
    admin: "师傅管理",
    newMaster: "新增师傅",
    editMaster: "编辑师傅",
    photo: "照片",
    active: "启用",
    bio: "介绍",
  },
  social: {
    title: "关注 Angelina",
    platforms: {
      instagram: "Instagram",
      facebook: "Facebook",
      tiktok: "TikTok",
      xhs: "小红书",
      whatsapp: "WhatsApp",
      wechat: "微信",
      other: "其他",
    },
  },
  events2: {
    addToCart: "加入购物车",
    addedToCart: "已加入购物车",
    eventInCart: "活动 · 已加入购物车",
  },
  cartTypes: {
    product: "商品",
    event: "活动",
  },
  qrDownload: "下载二维码",
};

const en = {
  nav: {
    home: "Home",
    about: "About",
    zeroSpace: "Zero Space",
    products: "Products",
    angelina: "Angelina",
    crystals: "Crystals",
    booking: "Booking",
    member: "Member",
    login: "Sign In",
    register: "Sign Up",
    logout: "Sign Out",
    admin: "Admin",
    dashboard: "Dashboard",
    agentCenter: "Agent Hub",
    profile: "Profile",
    cart: "Cart",
  },
  common: {
    zh: "中文",
    en: "EN",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    submit: "Submit",
    back: "Back",
    edit: "Edit",
    delete: "Delete",
    view: "View",
    upload: "Upload",
    share: "Share",
    copy: "Copy link",
    copied: "Copied",
    yes: "Yes",
    no: "No",
    optional: "optional",
    required: "required",
    all: "All",
    search: "Search",
    filter: "Filter",
    price: "Price",
    stock: "Stock",
    active: "Active",
    inactive: "Inactive",
    featured: "Featured",
    total: "Total",
    subtotal: "Subtotal",
    quantity: "Qty",
    empty: "No data",
    processing: "Processing...",
    saved: "Saved",
    close: "Close",
    comingSoon: "Coming soon",
    comingSoonDesc: "This section is being crafted with care. Stay tuned.",
  },
  brand: {
    tagline: "Culture · Creation · Spirit",
    subtitle: "Modern taste rooted in Eastern aesthetics",
  },
  home: {
    heroTitle: "Crystal Spirit · Creative Heart",
    heroSubtitle:
      "Crystals, fengshui, energy, incense and lotus — curated cultural pieces that bring stillness and inspiration.",
    ctaShop: "Shop the collection",
    ctaAbout: "About JinLin",
    featured: "Featured Pieces",
    featuredDesc: "This season's picks — quiet, thoughtful objects, chosen for you.",
    todayFortune: "Today's Fortune",
    todayFortuneDesc: "The daily fortune module arrives in Phase 3. Coming soon.",
    reminderTitle: "Gentle Reminder",
    reminderBody:
      "Your profile is missing birth details. Completing it unlocks more accurate services.",
    completeProfile: "Complete profile",
    dismiss: "Later",
  },
  auth: {
    login: "Sign In",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone",
    identity: "Identity",
    member: "Member",
    agent: "Sales Agent",
    agentNote:
      "Sales Agents require admin approval before agent features unlock. Member features remain available during review.",
    referralCode: "Referral code (optional)",
    referralApplied: "Referral code applied",
    haveAccount: "Already have an account?",
    noAccount: "No account yet?",
    loginHere: "Sign in",
    registerHere: "Create account",
    welcome: "Welcome back",
    google: "Sign in with Google",
    googleSignUp: "Sign up with Google",
    or: "or",
    signingIn: "Signing in…",
    createAccount: "Create your account",
    agentPending: "Your sales agent status is pending review. Using member features for now.",
    agentApproved: "Your sales agent status has been approved.",
    agentRejected: "Your agent application was not approved.",
  },
  profile: {
    title: "Profile",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    birthDate: "Date of birth",
    birthTime: "Time of birth",
    birthYear: "Year",
    birthMonth: "Month",
    birthDay: "Day",
    birthHour: "Hour",
    unknownHour: "Unknown",
    complete: "Profile complete",
    incomplete: "Profile incomplete",
    updated: "Profile updated",
  },
  products: {
    title: "Products",
    all: "All",
    crystal: "Crystal",
    fengshui: "Fengshui",
    energy: "Energy",
    incense: "Incense & Candle",
    lotus: "Lotus",
    addToCart: "Add to cart",
    buyNow: "Buy now",
    outOfStock: "Out of stock",
    inStock: "In stock",
    shareTitle: "Share this piece",
    shareCopy: "Copy link",
    shareWa: "Share via WhatsApp",
    description: "Description",
    added: "Added to cart",
    empty: "No products",
  },
  cart: {
    title: "Cart",
    empty: "Your cart is empty",
    emptyDesc: "Browse the collection to find your piece.",
    checkout: "Checkout",
    remove: "Remove",
    continueShopping: "Continue shopping",
    itemsCount: "{{n}} items",
  },
  checkout: {
    title: "Checkout",
    loginRequired: "Please sign in to check out",
    shipping: "Shipping information",
    shippingName: "Recipient name",
    shippingPhone: "Recipient phone",
    shippingAddress: "Shipping address",
    notes: "Notes (optional)",
    bankInfo: "Bank transfer details",
    bankName: "Bank",
    accountName: "Account name",
    accountNumber: "Account number",
    amount: "Amount to transfer",
    placeOrder: "Place order",
    afterOrder: "After placing the order, transfer the amount and upload your payment proof.",
  },
  order: {
    title: "Order",
    orderNo: "Order No.",
    status: "Status",
    date: "Placed on",
    uploadProof: "Upload payment proof",
    reuploadProof: "Re-upload proof",
    proofUploaded: "Proof uploaded. Awaiting admin review.",
    confirmed: "Order confirmed. Thank you!",
    rejected: "Order was rejected",
    rejectReason: "Rejection reason",
    contactWa: "Contact via WhatsApp",
    orderSuccess: "Order placed",
    orderSuccessDesc: "Please transfer and upload your payment proof. We'll confirm shortly.",
    goToOrder: "View order",
    history: "Order history",
    statuses: {
      pending_payment: "Pending payment",
      proof_uploaded: "Proof uploaded",
      confirmed: "Confirmed",
      rejected: "Rejected",
      cancelled: "Cancelled",
    },
  },
  admin: {
    title: "Admin",
    orders: "Orders",
    products: "Products",
    settings: "Site Settings",
    users: "Users",
    newProduct: "New product",
    editProduct: "Edit product",
    productName: "Product name",
    productDesc: "Description",
    category: "Category",
    price: "Price",
    promoPrice: "Promo price",
    images: "Product images",
    imagesHint: "Upload images or paste image URLs",
    addImageUrl: "Add image URL",
    uploadImage: "Upload image",
    orderList: "All orders",
    orderDetail: "Order detail",
    viewProof: "View proof",
    confirmOrder: "Confirm order",
    rejectOrder: "Reject order",
    rejectReasonHint: "Please provide a reason",
    uploadForCustomer: "Upload proof on behalf",
    stripeRefundNotice: "Note: this order was paid via Stripe. Rejecting here reverses points and commission — issue any refund manually in the Stripe dashboard.",
    contactCustomer: "Contact customer",
    saveSettings: "Save settings",
    settingsSaved: "Settings saved",
  },
  footer: {
    contact: "Contact",
    quickLinks: "Quick links",
    rights: "All rights reserved",
    tagline: "Culture · Creation · Spirit",
  },
  points: {
    title: "My Points",
    balance: "Points balance",
    history: "Points history",
    use: "Use points as discount",
    hint: "1 point = RM 1, applied against your order total",
    max: "Available",
    types: { earn: "Earned", spend: "Used", reverse: "Reversed", refund: "Refunded" },
  },
  agentHub: {
    title: "Agent Hub",
    referralCode: "Referral code",
    referralLink: "Referral link",
    copyLink: "Copy link",
    totalEarned: "Total earned",
    withdrawable: "Withdrawable",
    referredCount: "Referrals",
    monthly: "Monthly earnings",
    commissions: "Commission history",
    referrals: "Referred members",
    withdraw: "Request withdrawal",
    withdrawals: "Withdrawal history",
    amount: "Amount (RM)",
    minAmount: "Minimum RM 100",
    bankRequired: "Please add your bank info in profile first",
    bankInfo: "Bank information",
    bankHolder: "Account holder",
    bankName: "Bank",
    bankNumber: "Account number",
    statuses: { pending: "Pending", paid: "Paid", rejected: "Rejected" },
    requestSubmitted: "Withdrawal request submitted",
    joinDate: "Joined",
  },
  adminP2: {
    withdrawals: "Withdrawals",
    orgChart: "Org Chart",
    users: "Users",
    createUser: "New user",
    editUser: "Edit user",
    resetPassword: "Reset password",
    newPassword: "New password",
    role: "Role",
    agentStatus: "Agent status",
    approve: "Approve",
    reject: "Reject",
    markPaid: "Mark paid",
    downlines: "Downlines",
    noDownlines: "No downlines",
    all: "All",
  },
  fortune: {
    title: "Today's Fortune",
    ganzhi: "Ganzhi",
    lunar: "Lunar",
    zodiac: "Zodiac",
    clash: "Clash",
    mood: "Overall",
    yi: "Auspicious",
    ji: "Avoid",
  },
  events: {
    title: "Zero Space",
    subtitle: "Courses & Workshops",
    signup: "Sign up",
    location: "Location",
    price: "Fee",
    capacity: "Capacity",
    signupTitle: "Signup details",
    noteHint: "Note (optional)",
    signupSuccess: "Signup submitted. Awaiting admin confirmation.",
    mySignups: "My signups",
    statuses: { pending: "Pending", confirmed: "Confirmed", rejected: "Rejected" },
    empty: "No events",
    full: "Full",
  },
  booking: {
    title: "Life Booking",
    subtitle: "1-on-1 consultation",
    pickDate: "Pick a date",
    pickTime: "Pick a time",
    depositNotice: "A deposit confirms your slot (price varies by master)",
    concern: "What would you like to discuss?",
    submit: "Book slot",
    myBookings: "My bookings",
    minutes: "min",
    statuses: { pending_payment: "Pending payment", proof_uploaded: "Proof uploaded", confirmed: "Confirmed", rejected: "Rejected" },
    empty: "No bookings",
    noSlots: "No available slots",
    freed: "Slot has been freed",
    afterPay: "After creating the booking, transfer the shown amount and upload proof",
  },
  crystals: {
    title: "Crystals",
    subtitle: "Crystal Encyclopedia · Healing Knowledge",
    readMore: "Read more",
    empty: "No articles",
    categories: "Categories",
  },
  angelina: {
    title: "Angelina",
    subtitle: "Brand Ambassador",
    recommends: "Angelina Recommends",
  },
  reports: {
    title: "Report Requests",
    subtitle: "Numerology · Qimen",
    types: { numerology: "Numerology Report", qimen: "Qimen Report" },
    apply: "Apply",
    noteHint: "Additional notes (optional)",
    requireBirth: "Complete birth date + time in profile first",
    goProfile: "Complete profile",
    download: "Download",
    myRequests: "My requests",
    statuses: { pending: "Pending", completed: "Completed", rejected: "Rejected" },
    applied: "Request submitted",
    empty: "No requests",
  },
  analytics: {
    title: "Sales Analytics",
    revenue: "Total revenue",
    orders: "Orders",
    pending: "Pending orders",
    members: "Members",
    agents: "Agents",
    monthlyRevenue: "Monthly revenue",
    categoryRevenue: "By category",
    topProducts: "Top products",
    topAgents: "Top agents this month",
    recent: "Recent orders",
  },
  adminP3: {
    events: "Events",
    signups: "Signups",
    exportCsv: "Export CSV",
    slots: "Slots",
    newSlot: "New slot",
    bookings: "Bookings",
    articles: "Articles",
    newArticle: "New article",
    editArticle: "Edit article",
    articleCats: "Article categories",
    angelinaCms: "Angelina content",
    reports: "Reports",
    uploadReport: "Upload PDF",
    analytics: "Analytics",
  },
  adminCategories: {
    nav: "Categories",
  },
  masters: {
    title: "Masters",
    subtitle: "Meet the master",
    pickMaster: "Choose a master",
    all: "All masters",
    admin: "Masters",
    newMaster: "New master",
    editMaster: "Edit master",
    photo: "Photo",
    active: "Active",
    bio: "Bio",
  },
  social: {
    title: "Follow Angelina",
    platforms: {
      instagram: "Instagram",
      facebook: "Facebook",
      tiktok: "TikTok",
      xhs: "Xiaohongshu",
      whatsapp: "WhatsApp",
      wechat: "WeChat",
      other: "Other",
    },
  },
  events2: {
    addToCart: "Add to cart",
    addedToCart: "Added to cart",
    eventInCart: "Event · added to cart",
  },
  cartTypes: {
    product: "Product",
    event: "Event",
  },
  qrDownload: "Download QR",
};

i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    en: { translation: en },
  },
  lng: localStorage.getItem("jl_lang") || "zh",
  fallbackLng: "zh",
  interpolation: { escapeValue: false },
});

export default i18n;
